export const getStripedRowBackgroundColor = (rowIndex) => rowIndex % 2 === 1 ? 'neutral' : 'quiet';
